import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  enter(event) {
    // Prevent if clicking on dropdown or other interactive elements
    if (event.target.closest(".dropdown") || event.target.closest("button")) {
      return
    }

    const path = event.params.path
    if (path) {
      Turbo.visit(path)
    }
  }
}
